import Markdown, { MarkdownPreviewProps } from '@uiw/react-markdown-preview';
import * as React from 'react';
import rehypeSanitize from 'rehype-sanitize';

const MarkdownComponent: React.FC<MarkdownPreviewProps> = (props: MarkdownPreviewProps) => {
    return (
        <Markdown
            {...props}
            rehypePlugins={props.rehypePlugins ? [...props.rehypePlugins, rehypeSanitize] : [rehypeSanitize]}
            linkTarget="_blank"
            style={{
                maxWidth: '100%',
                overflowWrap: 'break-word',
                ...props?.style,
                backgroundColor: 'transparent',
            }}
        />
    );
};

export default MarkdownComponent;
